import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import { BlockMaxWidthWrapper } from "@/components/editor/shared/block-wrapper";
import BoothsSettings from "@/components/editor/shared/expo/booths-settings/booths-settings-component";

import BoothCard from "./booth-card/booth-card-component";
import {
  BackgroundColorWrapper,
  BoothsList,
  CenteredHeader,
  PaddingWrapper,
} from "./booths-component-styles";

type BoothsProps = {
  children?: React.ReactNode;
};

export default function Booths({ children }: BoothsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth={rem(1248)}>
          <CenteredHeader>
            <Element
              id="title"
              is={Text}
              text="Expo Booths"
              element="h2"
              pattern="headingTwo"
            />
          </CenteredHeader>
          <BoothsList>{children}</BoothsList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BackgroundColorWrapper>
  );
}

Booths.craft = {
  isCanvas: true,
  custom: {
    displayName: "Booths",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => BoothsSettings({ template: BoothCard }),
  },
};
